import { TwitterIcon } from "components/library/Icons";
import { HumanloopLogo } from "components/library/Logos";
import Button, { ButtonShade } from "components/library/Button";
import { useBreakpoints } from "hooks/useBreakpoints";
import {
  HOMEPAGE_LINK,
  PROGRAMMATIC_DOCS_LINK,
  TWITTER_LINK,
} from "utils/constants";

export const Header = () => {
  const { isMediumWidth } = useBreakpoints();
  return (
    <div className="mx-auto mb-[112px] flex w-full max-w-7xl items-center justify-between pt-24 pl-16 pr-8 md:py-40 md:px-40">
      <a href={HOMEPAGE_LINK}>
        <HumanloopLogo className="h-28 text-gray-800 hover:text-gray-900" />
      </a>

      <div className="flex gap-8">
        <Button href={PROGRAMMATIC_DOCS_LINK} size={isMediumWidth ? 32 : 24}>
          Documentation
        </Button>

        <Button
          href={TWITTER_LINK}
          IconLeft={TwitterIcon}
          styling="ghost"
          size={isMediumWidth ? 32 : 24}
          shade={ButtonShade.Gray}
        >
          Twitter
        </Button>
      </div>
    </div>
  );
};
